import { FONT } from "@/styles/fonts"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	display1: {
		fontSize: FONT.size.display1,
		lineHeight: "2.75rem",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	display2: {
		fontSize: FONT.size.display2,
		lineHeight: "2.25rem",
		fontFamily: "IBM Plex Sans, sans-serif"
	}
}))

export default useStyles